import { Navigation } from '@sketch-note/design-system/src/shared/site-settings';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { LmsSideBar, SideBar } from 'src/components/sidebar';
import { useLMSDashboardStore } from 'src/features/lms/store/useDashboardStore';
import { MainLayout } from 'src/layouts/main-layout';
import { useAuth } from 'src/shared/hooks/use-auth';
import { RootState } from 'src/store/reducers';
import { TOGGLE_SIDEBAR } from 'src/store/types';
export const OverviewLayout = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}): JSX.Element => {
  const dispatch = useDispatch();
  const { isSidebarOpened } = useSelector((state: RootState) => state.layout);
  const userDetails = useAuth((s) => s.userDetails);
  const { isInstructorSidebar } = useLMSDashboardStore();

  const router = useRouter();
  function handleToggleSideBar() {
    dispatch({ type: TOGGLE_SIDEBAR });
  }
  const isOverview = router.query?.lessons || router.query.templates ? true : false;
  return (
    <div>
      {userDetails?.authentication ? (
        <MainLayout
          isOverView={isOverview}
          sidebar={
            <>
              {isInstructorSidebar ? (
                <LmsSideBar
                  handleToggleSideBar={handleToggleSideBar}
                  isOpen={isSidebarOpened}
                  catalogHref={Navigation.Catalogue.href}
                  isOverview={isOverview}
                />
              ) : (
                <SideBar
                  handleToggleSideBar={handleToggleSideBar}
                  isOpen={isSidebarOpened}
                  catalogHref={Navigation.Catalogue.href}
                  isOverview={isOverview}
                />
              )}
            </>
          }
        >
          {children}
        </MainLayout>
      ) : (
        children
      )}
    </div>
  );
};
